import type {
  CurrencyDimensionMeta,
  StatementDataColumnConfiguration,
  StatementLineType,
} from "../../../../../../../../api/types/svTypes.ts";
import type { StatementLineState } from "../../../../store/types/fieldsState.types.ts";

const formattableLineTypes: StatementLineType[] = ["Amount", "Dimension", "Subtotal", "Total", "Formula"];

export const fixedCurrenciesOnly: CurrencyDimensionMeta[] = [];

export type FormatBlockSource =
  { kind: "line"; line: StatementLineState } | { kind: "column"; column: StatementDataColumnConfiguration };

export const getFormatBlocks = (
  lines: StatementLineState[],
  dataColumns: StatementDataColumnConfiguration[]
): FormatBlockSource[] => [
  ...lines
    .filter((line) => formattableLineTypes.includes(line.lineType))
    .map((line): FormatBlockSource => ({ kind: "line", line })),
  ...dataColumns
    .filter((column) => column.columnType === "Formula")
    .map((column): FormatBlockSource => ({ kind: "column", column })),
];
